import { render, staticRenderFns } from "./commonTitle.vue?vue&type=template&id=4a5ffd2a"
import script from "./commonTitle.vue?vue&type=script&lang=js"
export * from "./commonTitle.vue?vue&type=script&lang=js"
import style0 from "./commonTitle.vue?vue&type=style&index=0&id=4a5ffd2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports